// imports
import { useSetAtom } from "jotai";
import { useEffect } from 'react';

// lib files
import { APP_SIGN_IN_FEATURE_CATEGORY, ORIGIN_STRING } from '@/lib/constants';
import { appSignInAtom, PageStatusEnum } from "@/lib/atoms/app-sign-in";
import { isEmpty } from "@/lib/helpers/empty";
import { sendPbsGtmEvent } from "@/lib/helpers/send-pbs-gtm-event";
import { ssoLogoutLink } from "@/lib/helpers/sso-links";
import { useIdentity } from "@/lib/hooks/useIdentity";

// components
import Button from "@/components/Button/Button";
import LinkButton from "@/components/Button/LinkButton";

// styles
import styles from './ConfirmEmail.module.scss';


const ConfirmEmail = () => {
  const { cachedIdentity } = useIdentity()
  const setAppSignInState = useSetAtom(appSignInAtom);

  const hostname = isEmpty(ORIGIN_STRING) ? `https://${window.location.host}` : ORIGIN_STRING
  const useADifferentEmailRedirectURL = `${hostname}/tv/`;

  useEffect(() => {
    sendPbsGtmEvent({
      feature_category: APP_SIGN_IN_FEATURE_CATEGORY,
      feature_name: "user email confirmation",
      object_action: "user asked to confirm email",
    })
  }, [])

  const handleContinue = () => {
    sendPbsGtmEvent({
      feature_category: APP_SIGN_IN_FEATURE_CATEGORY,
      feature_name: "user email confirmation",
      object_action: "user confirmed email",
    })
    setAppSignInState((prevState) => ({
      ...prevState,
      pageStatus: PageStatusEnum.chooseStation
    }))
  };

  const handleUseDifferentEmail = () => {
    sendPbsGtmEvent({
      feature_category: APP_SIGN_IN_FEATURE_CATEGORY,
      feature_name: "user email confirmation",
      object_action: "user chose to use different email",
    })
  };

  return (
    <div className={styles.confirm_email}>
      <h2>Would you like to sign in with this account?</h2>
      <p className={styles.user_email}>{cachedIdentity?.email}</p>

      <div className={styles.confirm_email__options}>
        <Button style="white" onClick={handleContinue}>Continue</Button>
        <LinkButton
          href={`${ssoLogoutLink}?redirect=${useADifferentEmailRedirectURL}&signIn=true`}
          style='white_ghost'
          wrapperComponent='a'
          onClick={handleUseDifferentEmail}
        >
          Use a Different Email
        </LinkButton>
      </div>
    </div>
  );
};

export default ConfirmEmail;
